<script>
import { mapActions, mapState } from 'vuex';
import ReviewApprovalValues from '../../variables/reviewApprovalValues';

export default {
  name: 'ReviewApprovalStatusOverview',
  computed: {
    ...mapState({
      approved: state => state.review.overview.items.approved,
      disapproved: state => state.review.overview.items.disapproved,
      unresolved: state => state.review.overview.items.unresolved,
      approvalStatusFilter: state => state.review.overview.approvalStatusFilter,
    }),
  },
  data() {
    return {
      UNRESOLVED: ReviewApprovalValues.UNRESOLVED,
      APPROVED: ReviewApprovalValues.APPROVED,
      DISAPPROVED: ReviewApprovalValues.DISAPPROVED,
    };
  },
  methods: {
    ...mapActions({
      updateApprovalStatusFilter: 'review/updateApprovalStatusFilter',
      fetchApprovalStatusOverview: 'review/fetchApprovalStatusOverview',
    }),
  },
  created() {
    this.fetchApprovalStatusOverview();
  },
};
</script>

<template>
  <v-card class="elevation-3">
    <v-card-actions>
      <v-container>
        <v-layout>
          <v-flex class="text-align-center">
            <v-btn
              v-if="approvalStatusFilter === APPROVED"
              color="success"
              fab
              large
            >
              {{ approved }}
            </v-btn>
            <v-btn
              v-else
              @click="updateApprovalStatusFilter(APPROVED)"
              color="success"
              fab
              large
              outline
            >
              {{ approved }}
            </v-btn>
            <h2 class="mt-2">
              {{ $t('review.overview.approved') }}
            </h2>
          </v-flex>
          <v-flex class="text-align-center">
            <v-btn
              v-if="approvalStatusFilter === DISAPPROVED"
              color="error"
              fab
              large
            >
              {{ disapproved }}
            </v-btn>
            <v-btn
              v-else
              @click="updateApprovalStatusFilter(DISAPPROVED)"
              color="error"
              fab
              large
              outline
            >
              {{ disapproved }}
            </v-btn>
            <h2 class="mt-2">
              {{ $t('review.overview.disapproved') }}
            </h2>
          </v-flex>
          <v-flex class="text-align-center">
            <v-btn
              v-if="approvalStatusFilter === UNRESOLVED"
              color="warning"
              fab
              large
            >
              {{ unresolved }}
            </v-btn>
            <v-btn
              v-else
              @click="updateApprovalStatusFilter(UNRESOLVED)"
              color="warning"
              fab
              large
              outline
            >
              {{ unresolved }}
            </v-btn>
            <h2 class="mt-2">
              {{ $t('review.overview.unresolved') }}
            </h2>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-actions>
  </v-card>
</template>

<style scoped>
  .text-align-center {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/review/ReviewApprovalStatusOverview.vue